export default __webpack_public_path__ + "static/media/dsv-seur.7dd10a06.svg";